import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 4,
  class: "text-left"
}
const _hoisted_9 = { key: 5 }
const _hoisted_10 = {
  key: 6,
  class: "text-center"
}
const _hoisted_11 = { key: 7 }
const _hoisted_12 = {
  key: 8,
  class: "text-right"
}
const _hoisted_13 = { key: 9 }
const _hoisted_14 = {
  key: 10,
  class: "text-center pl-2 py-0"
}
const _hoisted_15 = { key: 11 }
const _hoisted_16 = {
  key: 12,
  class: "text-center pl-2 py-0"
}
const _hoisted_17 = {
  key: 13,
  class: "text-center pl-2 py-0"
}
const _hoisted_18 = { style: {"font-weight":"bold"} }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = {
  key: 0,
  class: "pl-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "11",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _cache[41] || (_cache[41] = _createElementVNode("h2", null, "Régularisations sur ventes", -1)),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps(props, {
                            size: "large",
                            class: "ml-2",
                            icon: "$oss-help"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[38] || (_cache[38] = _createElementVNode("p", { class: "mb-0" }, " Sont affichées les régularisations non lettrées, ayant comme date maximale la fin de l'exercice sélectionné. ", -1)),
                          _cache[39] || (_cache[39] = _createElementVNode("p", { class: "mb-0" }, " Effectuées avec les différents outils bobbee et avec des ODs manuelles. ", -1)),
                          _cache[40] || (_cache[40] = _createElementVNode("p", { class: "mb-0" }, " Les ODs ne peuvent pas être rattachées à un document d'origine (les 2 dernières colonnes seront vides). ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Message"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-chat",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createAdjustmentsData())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.disabledBtnGlobalValidation ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.accountingPeriod
                        ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    "data-cy": "CheckCustomersAdjustments-valid",
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[43] || (_cache[43] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.createAdjustmentsData('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.createAdjustmentsData('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[44] || (_cache[44] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[47] || (_cache[47] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          (_ctx.auditCheckResult && _ctx.auditCheckResult.id)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteAuditCheckResult(_ctx.auditCheckResult.id))),
                                title: `Supprimer les commentaires et les validations du contrôle`
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_tooltip, {
                                    location: "bottom",
                                    text: "Pour supprimer les régularisations bobbee, il faut supprimer le Cut-Off du document d'origine"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_icon, _mergeProps(props, {
                                        size: "small",
                                        icon: "$oss-trash"
                                      }), null, 16)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.displayActivityDialog = true))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[46] || (_cache[46] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[45] || (_cache[45] = [
                                  _createTextVNode("Afficher l'activité")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[48] || (_cache[48] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[49] || (_cache[49] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.closedPeriod)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2 mb-1",
                          size: "large"
                        }, {
                          default: _withCtx(() => _cache[50] || (_cache[50] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[51] || (_cache[51] = _createElementVNode("h3", null, "Période clôturée", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!Object.keys(_ctx.adjustments).length)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "1" }),
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => _cache[52] || (_cache[52] = [
                            _createElementVNode("h3", null, "Aucune régularisation enregistrée ou non lettrée", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.adjustments.length)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 2,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "5",
                              class: "ma-auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => _cache[53] || (_cache[53] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Régularisations non lettrées", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              class: "px-2 pt-1",
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => _cache[54] || (_cache[54] = [
                                                _createTextVNode(" $check_circle ")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                            _ctx.adjustmentsExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.adjustmentsExpand = !_ctx.adjustmentsExpand)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                          default: _withCtx(() => [
                            (_ctx.adjustments.length)
                              ? (_openBlock(), _createBlock(_component_v_card, {
                                  key: 0,
                                  elevation: "0",
                                  style: {"background-color":"white","border-radius":"25px"},
                                  class: "py-6 mt-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { class: "pa-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.adjustmentsHeaders,
                                          items: _ctx.adjustments,
                                          "multi-sort": "",
                                          loading: _ctx.loading,
                                          class: "table",
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          "no-data": _withCtx(() => _cache[55] || (_cache[55] = [
                                            _createTextVNode("Aucune anomalie")
                                          ])),
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (props.item.date)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_5, "-")),
                                              (
                                                    props.item.thirdPartyCompany &&
                                                    props.item.thirdPartyCompany.name
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(props.item.thirdPartyCompany.name), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_7, "-")),
                                              (props.item.wording)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(props.item.wording), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_9, "-")),
                                              (props.item.thirdPartyAccountableAccount)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(props.item.thirdPartyAccountableAccount), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_11, "-")),
                                              (
                                                    props.item
                                                        .thirdPartyAccountableAccountAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item
                                                            .thirdPartyAccountableAccountAmountSigned,
                                                        { currency: "", DC: true },
                                                    )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_13, "-")),
                                              (props.item.docId)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (_ctx.openDocument(props.item.docId)),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_15, "-")),
                                              (!props.item.originDocId)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$oss-eye-slash",
                                                      disabled: "",
                                                      size: "x-small"
                                                    })
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                                    (props.item.acrStatus === 'TO_UPDATE')
                                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                          key: 0,
                                                          text: "Le document d'origine a été modifié : veuillez recalculer les régularisations"
                                                        }, {
                                                          activator: _withCtx(({ props }) => [
                                                            _createVNode(_component_v_btn_warning, _mergeProps({
                                                              onClick: ($event: any) => (_ctx.openDocument(props.item.originDocId)),
                                                              color: "error"
                                                            }, props), null, 16, ["onClick"])
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                          key: 1,
                                                          icon: "$remove_red_eye",
                                                          onClick: ($event: any) => (_ctx.openDocument(props.item.originDocId)),
                                                          size: "x-small",
                                                          color: "primary"
                                                        }, null, 8, ["onClick"]))
                                                  ]))
                                            ])
                                          ]),
                                          "body.append": _withCtx(() => [
                                            _createElementVNode("tr", _hoisted_18, [
                                              _cache[56] || (_cache[56] = _createElementVNode("th", null, null, -1)),
                                              _cache[57] || (_cache[57] = _createElementVNode("th", null, null, -1)),
                                              _cache[58] || (_cache[58] = _createElementVNode("th", null, null, -1)),
                                              _cache[59] || (_cache[59] = _createElementVNode("th", null, null, -1)),
                                              _createElementVNode("th", _hoisted_19, [
                                                _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.previousPeriodTableSums(
                                                                "thirdPartyAccountableAccountAmountSigned",
                                                            ),
                                                            { currency: "", DC: true },
                                                        )), 1)
                                              ]),
                                              _cache[60] || (_cache[60] = _createElementVNode("th", null, null, -1)),
                                              _cache[61] || (_cache[61] = _createElementVNode("th", null, null, -1))
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items", "loading"]),
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, {
                                                  style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                                  class: "d-flex justify-end"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    (_ctx.closedPeriod || _ctx.validated)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          rounded: "",
                                                          disabled: "",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[62] || (_cache[62] = [
                                                            _createTextVNode(" OD ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          rounded: "",
                                                          class: "btn btn_blue",
                                                          onClick: _cache[12] || (_cache[12] = ($event: any) => {
                                                    _ctx.createAdjustmentsData();
                                                    _ctx.miscellanousOperationData = undefined;
                                                    _ctx.miscellaneousOperationDialog = true;
                                                }),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[63] || (_cache[63] = [
                                                            _createTextVNode(" OD ")
                                                          ])),
                                                          _: 1
                                                        })),
                                                    (_ctx.closedPeriod || _ctx.validated)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 2,
                                                          disabled: "",
                                                          rounded: "",
                                                          class: "btn btn_blue ml-2",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[64] || (_cache[64] = [
                                                            _createTextVNode(" Enregistrer ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 3,
                                                          rounded: "",
                                                          class: "btn btn_blue ml-2",
                                                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[65] || (_cache[65] = [
                                                            _createTextVNode(" Enregistrer ")
                                                          ])),
                                                          _: 1
                                                        })),
                                                    (_ctx.disabledBtnGlobalValidation)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 4,
                                                          rounded: "",
                                                          class: "btn btn_blue ml-2",
                                                          disabled: "",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[66] || (_cache[66] = [
                                                            _createTextVNode(" Valider ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (!_ctx.validated)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 5,
                                                            rounded: "",
                                                            class: "btn btn_blue ml-2",
                                                            onClick: _cache[14] || (_cache[14] = ($event: any) => {
                                                    _ctx.validated = !_ctx.validated;
                                                    _ctx.adjustmentsExpand = false;
                                                    _ctx.createAdjustmentsData('VALIDATE');
                                                }),
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                              _createTextVNode(" Valider ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 6,
                                                            rounded: "",
                                                            class: "btn btn_blue ml-2",
                                                            onClick: _cache[15] || (_cache[15] = ($event: any) => {
                                                    _ctx.validated = !_ctx.validated;
                                                    _ctx.createAdjustmentsData('UPDATE');
                                                }),
                                                            size: "small"
                                                          }, {
                                                            default: _withCtx(() => _cache[68] || (_cache[68] = [
                                                              _createTextVNode(" Invalider ")
                                                            ])),
                                                            _: 1
                                                          }))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.adjustmentsExpand]
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                      key: 3,
                      connectedDocuments: _ctx.connectedDocuments,
                      companyId: _ctx.companyId,
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      onUnlinkedDocument: _cache[16] || (_cache[16] = ($event: any) => (_ctx.unlinkDocument($event))),
                      onShowLinkedDocument: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showLinkedDocument($event)))
                    }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                      key: 4,
                      results: _ctx.results,
                      companyId: _ctx.companyId
                    }, null, 8, ["results", "companyId"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[69] || (_cache[69] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                      "data-cy": "CheckCustomersAdjustments-commentairesDetailles",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.commentExpand = !_ctx.commentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.commentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "expand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { class: "pt-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: _ctx.comment,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.comment) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          "auto-grow": "",
                                          style: {"border":"1px #ededed solid"},
                                          outlined: ""
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, {
                                      style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              rounded: "",
                                              disabled: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[20] || (_cache[20] = ($event: any) => {
                                            _ctx.createAdjustmentsData();
                                            _ctx.miscellanousOperationData = undefined;
                                            _ctx.miscellaneousOperationDialog = true;
                                        }),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            })),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue ml-2",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 3,
                                              rounded: "",
                                              class: "btn btn_blue ml-2",
                                              onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[73] || (_cache[73] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            })),
                                        (_ctx.disabledBtnGlobalValidation)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 4,
                                              rounded: "",
                                              class: "btn btn_blue ml-2",
                                              disabled: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[74] || (_cache[74] = [
                                                _createTextVNode(" Valider ")
                                              ])),
                                              _: 1
                                            }))
                                          : (!_ctx.validated)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 5,
                                                rounded: "",
                                                class: "btn btn_blue ml-2",
                                                onClick: _cache[22] || (_cache[22] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.adjustmentsExpand = false;
                                            _ctx.createAdjustmentsData('VALIDATE');
                                        }),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[75] || (_cache[75] = [
                                                  _createTextVNode(" Valider ")
                                                ])),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 6,
                                                rounded: "",
                                                class: "btn btn_blue ml-2",
                                                onClick: _cache[23] || (_cache[23] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.createAdjustmentsData('UPDATE');
                                        }),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[76] || (_cache[76] = [
                                                  _createTextVNode(" Invalider ")
                                                ])),
                                                _: 1
                                              }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[77] || (_cache[77] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      "data-cy": "CheckCustomersAdjustments-commentairesSynthetiques",
                                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.shortCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "expand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { class: "pt-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: _ctx.shortComment,
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.shortComment) = $event)),
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          "auto-grow": "",
                                          style: {"height":"auto","border":"1px #ededed solid"},
                                          outlined: ""
                                        }, null, 8, ["modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, {
                                      style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              rounded: "",
                                              disabled: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[26] || (_cache[26] = ($event: any) => {
                                            _ctx.createAdjustmentsData();
                                            _ctx.miscellanousOperationData = undefined;
                                            _ctx.miscellaneousOperationDialog = true;
                                        }),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                _createTextVNode(" OD ")
                                              ])),
                                              _: 1
                                            })),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue ml-2",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[80] || (_cache[80] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 3,
                                              rounded: "",
                                              class: "btn btn_blue ml-2",
                                              onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[81] || (_cache[81] = [
                                                _createTextVNode(" Enregistrer ")
                                              ])),
                                              _: 1
                                            })),
                                        (_ctx.disabledBtnGlobalValidation)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 4,
                                              rounded: "",
                                              class: "btn btn_blue ml-2",
                                              disabled: "",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[82] || (_cache[82] = [
                                                _createTextVNode(" Valider ")
                                              ])),
                                              _: 1
                                            }))
                                          : (!_ctx.validated)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 5,
                                                rounded: "",
                                                class: "btn btn_blue ml-2",
                                                onClick: _cache[28] || (_cache[28] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.adjustmentsExpand = false;
                                            _ctx.createAdjustmentsData('VALIDATE');
                                        }),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[83] || (_cache[83] = [
                                                  _createTextVNode(" Valider ")
                                                ])),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 6,
                                                rounded: "",
                                                class: "btn btn_blue ml-2",
                                                onClick: _cache[29] || (_cache[29] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.createAdjustmentsData('UPDATE');
                                        }),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                  _createTextVNode(" Invalider ")
                                                ])),
                                                _: 1
                                              }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => [
                                (_ctx.auditItems.accountableAccountsRoot.length)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_20, " Grand livre c/" + _toDisplayString(_ctx.getTextFromStringArray(_ctx.auditItems.accountableAccountsRoot)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      "data-cy": "CheckCustomersAdjustments-grandLivre",
                                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.generalLedgerExpand = !_ctx.generalLedgerExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives((_openBlock(), _createBlock(_component_v_card_text, {
                      transition: "expand",
                      key: _ctx.refreshGeneralLedger,
                      class: "pa-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_GeneralLedger, {
                          companyId: _ctx.companyId,
                          accountingPeriodId: _ctx.accountingPeriod.id,
                          accountableAccountFilter: _ctx.auditItems.accountableAccountsRoot,
                          inNm1: false,
                          hideOptions: true,
                          withoutLetteringIfHidedOptions: true,
                          hideBodyAppend: true,
                          enableAuditedAccountableAccounts: true
                        }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter"])
                      ]),
                      _: 1
                    })), [
                      [_vShow, _ctx.generalLedgerExpand]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.displayActivityDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 5,
                      modelValue: _ctx.displayActivityDialog,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                      title: "Activité",
                      "valid-title": "Fermer",
                      onValid: _cache[32] || (_cache[32] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      onClose: _cache[33] || (_cache[33] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UsersActivitiesHistory, {
                          auditCheckKey: _ctx.acKey,
                          accountingPeriodId: _ctx.accountingPeriodId
                        }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_oss_dialog, {
                  modelValue: _ctx.miscellaneousOperationDialog,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
                  actions: _ctx.actionsMiscellaneousOperation,
                  "min-width": "90vw"
                }, {
                  default: _withCtx(() => [
                    (_ctx.miscellaneousOperationDialog)
                      ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                          key: 0,
                          companyId: _ctx.companyId,
                          prefilledRows: _ctx.miscellanousOperationData,
                          acKey: _ctx.acKey,
                          auditCheckResult: _ctx.auditCheckResult,
                          accountingPeriodId: _ctx.accountingPeriodId,
                          onUpsert: _cache[34] || (_cache[34] = ($event: any) => (_ctx.refresh())),
                          actions: _ctx.actionsMiscellaneousOperation
                        }, null, 8, ["companyId", "prefilledRows", "acKey", "auditCheckResult", "accountingPeriodId", "actions"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "actions"]),
                (_ctx.openChat)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 6,
                      auditCheckAccountingPeriodKey: _ctx.chatId,
                      chatTitle: 'Chat'
                    }, null, 8, ["auditCheckAccountingPeriodKey"]))
                  : _createCommentVNode("", true),
                (_ctx.dialogAuditCheckDocumentsManager)
                  ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                      key: 7,
                      modelValue: _ctx.dialogAuditCheckDocumentsManager,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                      disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                      companyId: _ctx.companyId,
                      documentToDisplay: _ctx.documentToDisplay,
                      connectedDocuments: _ctx.connectedDocuments || [],
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                      onUpsertedAuditCheckResult: _ctx.upsertedACR,
                      onResetDialogData: _cache[37] || (_cache[37] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                    }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ]),
    _: 1
  }))
}